import { formatRackLocationLabel } from "src/utils/rackLocations";

export const getDisplayRackLocations = ({ item, asset = item?.asset }) => {
  const assignedRackLocations = Array.isArray(item?.rackLocations) ? item.rackLocations : [];

  if (assignedRackLocations.length > 0 || !item?.nonAllocating) {
    return assignedRackLocations;
  }

  return Array.isArray(asset?.rackLocations) ? asset.rackLocations : [];
};

export const getWarehouseId = rackLocation => {
  const warehouse = rackLocation?.warehouse;

  if (typeof warehouse === "string") {
    return warehouse;
  }

  return warehouse?.warehouse_id || warehouse?.warehouseId || null;
};

export const getSourceRackLocationOptions = assetRackLocations =>
  (Array.isArray(assetRackLocations) ? assetRackLocations : []).map((rackLocation, index) => ({
    id: rackLocation?.entry_uid || `${getWarehouseId(rackLocation) || "warehouse"}-${index}`,
    index,
    label: formatRackLocationLabel(rackLocation, { includeQty: true, fallback: "Unknown location" }),
    rackLocation,
  }));

export const buildNonAllocatingTransactionPayload = ({
  assetRackLocations,
  sourceLocationOption,
  destination,
}) => {
  const oldRackLocations = (Array.isArray(assetRackLocations) ? assetRackLocations : []).map(rackLocation => ({
    ...rackLocation,
  }));
  const sourceRackLocation = sourceLocationOption?.rackLocation;
  const sourceSubQty = sourceRackLocation?.sub_qty || 0;
  const rackLocations = oldRackLocations.map((rackLocation, index) =>
    index === sourceLocationOption?.index
      ? { ...rackLocation, ...destination, sub_qty: sourceSubQty }
      : rackLocation
  );
  const rackLocationsChanges = [{ ...destination, sub_qty: sourceSubQty }];

  return {
    oldRackLocations,
    rackLocations,
    rackLocationsChanges,
  };
};
